module.exports = __webpack_public_path__ + "img/content-img-4.d77697ba.jpg";